// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.


const ComponentBackdrop: React.FC<{
  parent?: HTMLElement | null,
  visible?: boolean
}> = ({
  parent,
  visible
}) => {
  const style: {width?: string, height?: string} = {}
  if (parent !== null) {
    style.height = `${parent?.clientHeight}px`
    style.width = `${parent?.clientWidth}px`
  }
  if (!visible) { return null }
  return (
    <div className="loading-backdrop" style={style}></div>
  )
}

export { ComponentBackdrop }